import React from 'react'
import {connect} from 'react-redux';
import Pay from '../components/Pay'
import {Page} from '../components'
import Config from '../config'


class PgyMallPay extends React.Component {
    componentWillMount() {
        document.title = '微信安全支付'
    }

    componentWillUnmount() {
        document.title = '十方教育'
    }

    componentDidMount() {
        setTimeout(() => {
            this.props.dispatch({
                type: 'PAY_PGY_VIP',
                payload: {
                    params: {
                        product: 'pgy_pay_vip'
                    },
                    success: (data) => {
                        location.replace(`${Config.PGY_MALL_URL}/paySuccess`)
                    }
                }
            })
        }, 2000)
    }

    render() {
        return (
            <Page parent={this}>
                <div className="wk-page" style={{textAlign: 'center', minHeight: '100vh', background: '#fff'}}>
                    <Pay />
                    <img style={{width: '80%'}} src="https://static-1253442168.image.myqcloud.com/picture/7832811_244c82048d5e4f7491b518e11980ae41.jpg"/>
                    <p style={{fontSize: '16px', color: '#000', marginTop: '-80px'}}>会员名额抢购中...</p>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({

}))(PgyMallPay);



// WEBPACK FOOTER //
// ./src/pages/PgyMallPay.js